import validationStore from "../../../helpers/regexValidators";

export default (history) => {
  const urlParams = history.location.pathname.split("/");
  let token = null;
  let uid = null;
  let email = null;

  if (urlParams.length === 10) {
    token = urlParams[8];
    uid = urlParams[7];
    email = urlParams[2];
  }
  return {
    initialState: {
      token: { value: token ? token : "", error: "" },
      uid: { value: uid ? uid : "", error: "" },
      newPassword: { value: "", error: "" },
      newPassword2: { value: "", error: "" },
      email: { value: email ? email : "", error: "" },
    },
    validationStateSchema: {
      token: {},
      uid: {},
      newPassword: {
        required: true,
        validator: {
          regEx: validationStore.password,
          error: "Las contraseñas deben de contener al menos 6 caracteres.",
        },
      },
      newPassword2: {
        required: true,
        equalsField: {
          field: "newPassword",
          error: "Las contraseñas no son iguales.",
        },
      },
      email: {},
    },
  };
};
